import React from 'react';
import Link from "../primitives/link";
import { colors } from '../primitives/colors';

const dummyData = {
  crumbs: [
    {
      href: '/',
      text: 'Breadcrumb 1'
    },
    {
      href: '/',
      text: 'Breadcrumb 2'
    },
    {
      href: '/',
      text: 'Breadcrumb 3'
    }
  ]
};

const Breadcrumbs = ({ data, ...props }) => {
  const { crumbs } = data || dummyData;
  const enabled = false;

  return (enabled) ? (
    <nav {...props} css={styles.nav} aria-labelledby="breadcrumbs-label">
      <h3 css={styles.navLabel} id="breadcrumbs-label">Breadcrumbs</h3>
      <ul css={styles.navLinks}>
        {crumbs.map(crumb => (
          <Link css={styles.navLink} className="hover-default" key={crumb.text} to={crumb.href}>
            {crumb.text}
          </Link>
        ))}
      </ul>
    </nav>
  ) : (<></>);
};

const styles = {
  nav: {
    color: colors.primaryOrange,
    paddingBottom: "2rem"
  },
  navLabel: {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: "0",
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    borderWidth: "0"
  },
  navLinks: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    ">:not([hidden])~:not([hidden])": {
      borderLeftWidth: "1px",
      borderColor: colors.primaryOrange,
    }
  },
  navLink: {
    paddingLeft: "0.5rem",
    paddingRight: "0.5rem",
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
    fontWeight: 500,
    letterSpacing: "0.05em"
  }
};

export default Breadcrumbs;
